import React from 'react';
import styles from '../assets/styles/Pro.module.css';

const Pro = ({ icon, header, description }) => {
  return (
    <div>
      <div className={styles.pro}>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.textContent}>
          <div className={styles.header}>{header}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
    </div>
  );
};

export default Pro;